import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App.jsx';
import { ConfirmProvider } from './components/ConfirmDialog.jsx';
import UpdateBanner from './components/UpdateBanner.jsx';
import './index.css';

// React Query — defaults are deliberately conservative for a mobile app
// that may flick in and out of connectivity. We don't auto-refetch on
// window focus (annoying when the OS keyboard appears and the visual
// viewport shrinks) and rely on explicit invalidation after mutations.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* ConfirmProvider must wrap App so any page can call useConfirm()
            for in-app confirmation modals (replaces native window.confirm). */}
        <ConfirmProvider>
          <App />
          {/* Renders nothing until vite-plugin-pwa flags a waiting SW; then
              shows a bottom snackbar that swaps in the new build on tap.
              Mounted at the root so it overlays every route. */}
          <UpdateBanner />
        </ConfirmProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
